import { render, staticRenderFns } from "./CometPreview.vue?vue&type=template&id=644a667c&scoped=true"
import script from "./CometPreview.vue?vue&type=script&lang=js"
export * from "./CometPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644a667c",
  null
  
)

export default component.exports